/* Meta Pixel: base code + standard events for a Shopify-linked landing page.
 * Product/cart clicks are tracked by delegation on outbound acevanity.in links, so every card, drawer, chat link
 * and CTA is covered without touching each component. Purchase itself fires from the same pixel on Shopify. */
const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const SHOP_HOST = "acevanity.in";

export const pixelEnabled = () => Boolean(PIXEL_ID);

/** Safe wrapper: no-op when the pixel is not configured or blocked by the browser. */
export const track = (event, params, custom = false) => {
  if (!window.fbq) return;
  window.fbq(custom ? "trackCustom" : "track", event, params);
};

const loadBase = () => {
  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
    if (!f._fbq) f._fbq = n;
    n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
    t = b.createElement(e); t.async = !0; t.src = v;
    s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", PIXEL_ID);
  window.fbq("track", "PageView");
};

/** Reads product info off an outbound store link: /products/<handle> or /cart/<variant>:<qty>. */
const describe = (a) => {
  const url = new URL(a.href, window.location.href);
  if (url.hostname === "wa.me") return { kind: "whatsapp", params: { content_name: "whatsapp" } };
  if (!url.hostname.endsWith(SHOP_HOST)) return null;
  const product = url.pathname.match(/^\/products\/([^/?#]+)/);
  const cart = url.pathname.match(/^\/cart\/(\d+):(\d+)/);
  const price = Number(a.dataset.price || a.closest("[data-price]")?.dataset.price);
  const name = a.dataset.name || a.closest("[data-name]")?.dataset.name;
  const variant = a.dataset.variant || a.closest("[data-variant]")?.dataset.variant;
  const money = Number.isFinite(price) && price > 0 ? { value: price, currency: "INR" } : {};
  if (cart) return { kind: "cart", params: { content_ids: [cart[1]], content_type: "product", num_items: Number(cart[2]), content_name: name, ...money } };
  if (product) return { kind: "product", params: { content_ids: [variant || product[1]], content_type: "product", content_name: name, ...money } };
  if (url.pathname.startsWith("/collections/")) return { kind: "collection", params: { content_name: url.pathname.split("/").pop() } };
  return null;
};

const onClick = (e) => {
  const a = e.target.closest?.("a[href]");
  if (!a) return;
  let info;
  try {
    info = describe(a);
  } catch {
    return;
  }
  if (!info) return;
  if (info.kind === "cart") {
    track("AddToCart", info.params);
    track("InitiateCheckout", info.params);
  } else if (info.kind === "product") {
    track("ViewContent", info.params);
  } else if (info.kind === "collection") {
    track("ViewCollection", info.params, true);
  } else {
    track("Contact", info.params);
  }
};

/** Call once at app start. Returns a cleanup function. */
export const initPixel = () => {
  if (!pixelEnabled()) return () => {};
  loadBase();
  document.addEventListener("click", onClick, true);
  return () => document.removeEventListener("click", onClick, true);
};
